/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
import { Route, Switch, Redirect } from "react-router";
// redux
import { useSelector } from 'react-redux';
// material
import { Division } from "@insticator/insticator-ui";
// pages
import MCMPage from "./mcm/mcm";
import AdServeBlocking from "./adServeBlocking/adServeBlocking";
// styles
import injectSheet from "react-jss";


/* ========== ~~~~~~~~~~ GLOBAL SETTINGS DIVISION ~~~~~~~~~~ ========== */
const GlobalSettingsDivision = props => {

    return (
        <Division name={'settings'}>
            <Switch>
                <Route exact path='/dashboard/globalsettings' render={() => <Redirect to={'dashboard/globalsettings/mcm'} />} />
                <Route path='/dashboard/globalsettings/mcm' component={MCMPage} />
                <Route path='/dashboard/globalsettings/adServeBlocking' component={AdServeBlocking} />
                <Redirect to='/error/404' />
            </Switch>
        </Division>
    )
}
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default GlobalSettingsDivision;